function CustomSelect() {
    const customSelect = document.querySelector('.custom-select');
    const selected = customSelect?.querySelector('.js-select-selected');
    const options = customSelect?.querySelectorAll('.option');
    const hiddenInput = document.getElementById('referral_source_hidden');

    if (customSelect && selected && options.length && hiddenInput) {
        const firstOption = options[0];
        selected.textContent = firstOption.textContent;
        hiddenInput.value = firstOption.dataset.value;

        selected.addEventListener('click', () => {
            customSelect.classList.toggle('open');
        });

        options.forEach(option => {
            option.addEventListener('click', () => {
                selected.textContent = option.textContent;
                hiddenInput.value = option.dataset.value;
                customSelect.classList.remove('open');
            });
        });

        document.addEventListener('click', e => {
            if (!e.target.closest('.custom-select')) {
                customSelect.classList.remove('open');
            }
        });
    }


}

export { CustomSelect };
